<div class="modal-body">
  <div  style="width: 100%;height: 100%;">
    <div id="header" class="row justify-content-between no-gutters">
      <label>{{ header }}</label>
      <div class="close-button" (click)="dialogRef.close()"></div>
    </div>
    <ll-pass-list [events]="events" *ngIf="hasEvents" [dialogRef]="dialogRef"></ll-pass-list>

    <div id="no-events" *ngIf="!hasEvents">
      There are no passes on this date.
    </div>
    <div id="footer" class="row justify-content-center no-gutters">
      <div class="submit-button" (click)="addPass()">
        Add Pass
      </div>
    </div>
  </div>
</div>
